import React from 'react';
import { useIntl } from 'react-intl';

const DEFAULT_PRECISION = 2;

const useInputPrecision = (currencyIsoCode: string | undefined, precisionProp: number | undefined): number => {
  const { locale } = useIntl();

  const derivedPrecision = React.useMemo<number>(() => {
    if (!currencyIsoCode) {
      return DEFAULT_PRECISION;
    }

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyIsoCode,
    }).resolvedOptions().minimumFractionDigits ?? DEFAULT_PRECISION;
  }, [currencyIsoCode, locale]);

  return precisionProp ?? derivedPrecision;
};

export default useInputPrecision;
